module.exports = __webpack_public_path__ + "static/media/agema.54088a5e.png";